import LoadingWheel from '../../atoms/LoadingWheel';
import { translate } from '../../../localization';
import styles from './Loading.module.css';

const Loading = () => {
  return (
    <div className={styles.loading}>
      <LoadingWheel size={32} />
      <span className={styles.loading__text}>
        {translate('file_uploader_loading')}
      </span>
    </div>
  );
};

Loading.displayName = 'Loading';

export default Loading;
